'use client';

import type { ReactElement, ReactNode } from 'react';
import { Tooltip as TooltipPrimitive } from 'radix-ui';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

// Rail labels must escape both the sidebar's and the nav's scrolling clips.
export function ShellTooltip({
  children,
  label,
}: {
  children: ReactElement;
  label: ReactNode;
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipPrimitive.Portal>
        <TooltipContent side="right">{label}</TooltipContent>
      </TooltipPrimitive.Portal>
    </Tooltip>
  );
}
